"use client";

import { faHeart } from "@fortawesome/pro-solid-svg-icons";
import { useTranslations } from "next-intl";
import { Icon } from "@/components/ui/Icon";
import { Link } from "@/i18n/navigation";
import { useWishlist } from "./WishlistContext";

export function WishlistLink() {
	const t = useTranslations("shop");
	const { count } = useWishlist();

	return (
		<Link
			href="/wishlist"
			aria-label={t("wishlist")}
			className="relative inline-flex size-9 items-center justify-center rounded-lg border border-border transition hover:bg-surface-2"
		>
			<Icon icon={faHeart} size={16} />
			{count > 0 && (
				<span
					className="absolute -end-1 -top-1 inline-flex h-4 min-w-4 items-center justify-center rounded-full px-1 text-[10px] font-bold"
					style={{ background: "var(--primary)", color: "var(--primary-foreground)" }}
				>
					{count}
				</span>
			)}
		</Link>
	);
}
